import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import LoadingPage from './pages/LoadingPage';
import PrivacyPage from './pages/PrivacyPage';
import AccountDeletePage from './pages/AccountDeletePage';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LoadingPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/acc-delete" element={<AccountDeletePage />} />
      </Routes>
    </Router>
  );
}

export default App;
